import { Star } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal, Eyebrow } from "./Reveal";

const LEMON_IMG = "/photos/garden_1.jpg";

export default function Intro() {
  const { t } = useLang();

  return (
    <section id="oasi" className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36">
      <div className="grid items-center gap-14 md:grid-cols-12 md:gap-10">
        <div className="md:col-span-7">
          <Reveal>
            <Eyebrow>{t.intro.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-serif text-4xl font-light leading-[1.05] md:text-6xl">
              {t.intro.title}
              <br />
              <span className="italic text-olive">{t.intro.titleAccent}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-ink2 md:text-lg">
              {t.intro.p1}
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-ink2 md:text-lg">
              {t.intro.p2}
            </p>
          </Reveal>

          <Reveal delay={0.3} className="mt-12 flex gap-14">
            <div>
              <p className="font-serif text-6xl font-light text-terra md:text-7xl">
                {t.intro.stat1n}
              </p>
              <p className="mt-2 text-[11px] uppercase tracking-[0.25em] text-ink2">
                {t.intro.stat1l}
              </p>
            </div>
            <div className="border-l border-line pl-14">
              <p className="font-serif text-6xl font-light text-ink md:text-7xl">{t.intro.stat2n}</p>
              <p className="mt-2 text-[11px] uppercase tracking-[0.25em] text-ink2">
                {t.intro.stat2l}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="relative md:col-span-5">
          <Reveal delay={0.15} y={40}>
            <div className="arch overflow-hidden" data-testid="intro-image">
              <img
                src={LEMON_IMG}
                alt="La piscina privata e la villa viste dall'alto"
                className="aspect-[4/5] w-full object-cover transition-transform duration-[1.4s] ease-out hover:scale-105"
                loading="lazy"
              />
            </div>
          </Reveal>
          <Reveal
            delay={0.35}
            className="absolute -bottom-6 -left-4 md:-left-10"
          >
            <div className="flex items-center gap-3 rounded-xl border border-line bg-sand/85 px-5 py-4 shadow-lg backdrop-blur-xl">
              <span className="flex text-terra">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4" fill="currentColor" strokeWidth={0} />
                ))}
              </span>
              <span className="text-sm font-semibold">{t.intro.chip}</span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
